<ion-content class="ion-padding">
    <div class="max-page-width">
        <ion-item lines="none" mode="ios" class="title-with-back-button">
            <ion-button fill="clear" mode="ios" color="primary" (click)="goBack()">
                <ion-icon class="bp-arrow-left"></ion-icon>
            </ion-button>
            <ion-label class="ion-text-center ion-text-wrap"> {{ getText(processConfig?.globalizationConfig, 'title') |
                uppercase }} </ion-label>
        </ion-item>

        <br />

        <app-step-description [description]="getText( processConfig?.globalizationConfig, 'instructions' )">
        </app-step-description>

        <ng-container *ngIf="status === ProcessStatus.WaitingInput">
            <ng-container *ngFor="let area of areas; let areaIndex = index">
                <ion-card mode="ios" class="card-table-data">
                    <h2>
                        {{ getText(area.globalizationConfig, 'title') | uppercase }}
                        <!-- <ng-container *ngIf="area.requiresEvaluatorsValidation">
                          ({{ area.minEvaluators}} - {{ area.maxEvaluators }})
                        </ng-container> -->
                    </h2>

                    <ng-container *ngIf="status === ProcessStatus.WaitingInput">
                        <ion-card-header>
                            <ion-grid>
                                <ion-row style="width: 100%">
                                    <ion-col size="9">
                                        <ion-searchbar mode="ios" #userSearchSame class="section-search-custom"
                                            [placeholder]="'generic.searchByName' | translate"> </ion-searchbar>
                                    </ion-col>
                                    <ion-col size="3">
                                        <div class="btn-group">
                                            <ion-button text-wrap mode="ios" expand="block" slot="end"
                                                (click)="loadUsers(areaIndex, userSearchSame)">
                                                {{ 'generic.ThreeSixtyEvaluationValidationGetUsers' | translate }}
                                            </ion-button>
                                        </div>
                                    </ion-col>
                                </ion-row>
                            </ion-grid>
                        </ion-card-header>
                    </ng-container>

                    <div class="users-selected">
                        <ion-chip *ngFor="let user of selectedUsers[areaIndex]; let index = index"
                            [color]="user.flags?.length > 0 && (!sendEvalForThreeSixtyClosed || !user.flags.includes('360evaluation.360Finished')) ? 'danger' : 'primary' ">
                            <ion-avatar>
                                <img [src]="getImageUrl(user.imageUrl)" default="" alt="" />
                            </ion-avatar>
                            <ion-label>{{ user.name }}</ion-label>
                            <ion-icon *ngIf="status === ProcessStatus.WaitingInput" class="bp-close" name="closeIcon"
                                (click)="removeUser(areaIndex, index)"></ion-icon>
                        </ion-chip>
                    </div>

                    <ion-list class="users">
                        <ion-item
                            [color]="user.flags?.length > 0 && (!sendEvalForThreeSixtyClosed || !user.flags.includes('360evaluation.360Finished')) ? 'danger' : ''"
                            *ngFor="let user of users[areaIndex]" class="user-item"
                            (click)="selectUser(user, areaIndex)">
                            <div class="users-container">
                                <div class="users-container-name">
                                    <span>
                                        <b>{{ user.name }}</b>
                                        <ng-container *ngIf="!hideAttributesFromUserSearchOn360">
                                            - {{ user.attribute1 }} / {{ user.attribute2 }}
                                        </ng-container>
                                    </span>
                                    <span *ngIf="showSelectedCountOnSelection360">
                                        {{ user.selectedCount }} {{ '360evaluation.selected' | translate | lowercase }}
                                    </span>

                                    <span *ngIf="user.aboveSelectionLimit" class="warning-selection-box">
                                        <ion-icon size="small" class="bp-info" name="information-circle"
                                            style="color: #f6bd3a"></ion-icon>
                                        &nbsp; {{aboveSelectionLimitMessage}}
                                    </span>
                                </div>
                                <br />

                                <span *ngIf="user.flags?.length === 0" class="hoverable"> ({{
                                    '360evaluation.clickToSelect' | translate | lowercase }}) </span>
                                <span *ngFor="let error of user.flags" class="hoverable">
                                    ({{ error | translate }}
                                    <b
                                        *ngIf="error === '360evaluation.hasAttribute' || error === '360evaluation.doesNotHaveAttribute' ">
                                        {{returnAttributeType(areaIndex)}}</b>)
                                </span>
                            </div>
                        </ion-item>
                    </ion-list>
                </ion-card>
            </ng-container>
        </ng-container>

        <ion-item lines="none" mode="ios" class="title-with-back-button" *ngIf="status !== ProcessStatus.WaitingInput">
            <p style="text-align: center; width: 100%">
                <ng-container *ngIf="status === ProcessStatus.AllowedViewingWithWarnings"> {{
                    '360evaluation.WaitingForAproval' | translate }} </ng-container>

                <ng-container *ngIf="status === ProcessStatus.AllowedViewing"> {{ '360evaluation.Aproved' | translate }}
                </ng-container>
            </p>
        </ion-item>

        <ng-container *ngIf="status === ProcessStatus.WaitingInput">
            <div class="bottom-buttons" text-right>
                <ion-button mode="ios" color="secondary" class="send" (click)="save()"> {{ '360evaluation.save' |
                    translate }} </ion-button>
            </div>
        </ng-container>
    </div>
</ion-content>